import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import _get from '@babel/runtime/helpers/get';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function (sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === 'undefined' || !Reflect.construct)
        return false;
    if (Reflect.construct.sham)
        return false;
    if (typeof Proxy === 'function')
        return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {
        }));
        return true;
    } catch (e) {
        return false;
    }
}
import _ from 'lodash';
import DPlayer from '../core/index';
import PictureInPicture from '../core/picture-in-picture';
import utils from '../core/utils';
import Monitor from './monitor';
import Feedback from './feedback';
import EndPanel from './endpanel';
import TurnOffLight from './turn-off-light';
import MiniPlayer from './miniplayer';
import KeyboardForbidden from './forbidden';
import Interaction from './interaction';
import EventEmitter from './event-emitter';
import handlerUserInfoOptions from './options';
var MtPlayer = function (_DPlayer) {
    _inherits(MtPlayer, _DPlayer);
    var _super = _createSuper(MtPlayer);
    function MtPlayer(options) {
        var _this;
        _classCallCheck(this, MtPlayer);
        _this = _super.call(this, options);
        _this.hasLoaded = false;
        _this.pauseStart = 0;
        _this.replayCount = 0;
        if (!utils.isMobileOrElectron && options.pictureinpicture) {
            _this.pictureInPicture = new PictureInPicture(_assertThisInitialized(_this));
        }
        _this.userInfo = handlerUserInfoOptions(options.userInfo);
        _this.socket = options.socket;
        if (_this.socket) {
            _this.monitor = new Monitor(_assertThisInitialized(_this));
        }
        if (options.feedback) {
            _this.feedback = new Feedback(_assertThisInitialized(_this));
        }
        if (options.endpanel) {
            _this.endPanel = new EndPanel(_assertThisInitialized(_this));
        }
        if (options.light) {
            _this.turnOffLight = new TurnOffLight(_assertThisInitialized(_this));
        }
        _this.forbidden = new KeyboardForbidden(_assertThisInitialized(_this));
        if (options.highlight) {
            _this.interaction = new Interaction(_assertThisInitialized(_this));
        }
        if (options.miniPlayer) {
            _this.miniPlayer = new MiniPlayer(_assertThisInitialized(_this));
        }
        if (options.collection) {
        }
        _this.emitter = new EventEmitter(_assertThisInitialized(_this));
        _this.startTime = Date.now();
        _this.startPlayTime = 0;
        _this.bufferTime = 0;
        _this.loadedTime = 0;
        _this.isFirstPlay = true;
        _this.waitingTimer = null;
        _this.startWaitingTime = Date.now();
        _this.startSwitchCDNTime = 0;
        _this.hasEmitInit = false;
        _this.cdnSeedOkDur = 0;
        _this.startWaitingTimer();
        _this.initSeekWarning();
        _this.initEvents();
        _this.initPlaybackRatesButton();
        return _this;
    }
    _createClass(MtPlayer, [
        {
            key: 'startWaitingTimer',
            value: function startWaitingTimer() {
                var _this2 = this;
                this.waitingTimer = setInterval(function () {
                    if (_this2.video.readyState > 3 || _this2.video.paused) {
                        _this2.startWaitingTime = null;
                        return;
                    }
                    if (!_this2.startWaitingTime) {
                        _this2.startWaitingTime = Date.now();
                    }
                    if (_this2.emitter.currentEventName !== 'VIDEO_BLOCK') {
                        _this2.emitter.emit('VIDEO_BLOCK');
                    }
                    if (Date.now() - _this2.startWaitingTime >= 4000) {
                        _this2.startWaitingTime = Date.now();
                        _this2.switchToNextCDN();
                    }
                }, 2000);
            }
        },
        {
            key: 'initPlaybackRatesButton',
            value: function initPlaybackRatesButton() {
                var _this3 = this;
                if (this.options.playbackRates) {
                    this.template.playbackRate.addEventListener('click', function (e) {
                        if (e.target.classList.contains('dplayer-playback-item')) {
                            var rate = e.target.dataset.index;
                            Array.prototype.slice.call(_this3.template.playbackItem).forEach(function (item, i) {
                                if (item.classList.contains('dplayer-playback-active')) {
                                    item.classList.remove('dplayer-playback-active');
                                }
                            });
                            e.target.classList.add('dplayer-playback-active');
                            _this3.speed(rate);
                            _this3.template.playbackRateButton.innerHTML = ''.concat(rate, 'X');
                        }
                    });
                }
            }
        },
        {
            key: 'initEvents',
            value: function initEvents() {
                var _this4 = this;
                this.on('durationchange', function () {
                    if (typeof _this4.video.duration === 'number') {
                        _this4.emitter.commonParam.sourceTime = _this4.video.duration.toFixed(2);
                    }
                    var volume = localStorage.getItem('dplayer-volume') || 0;
                    if (!_this4.hasEmitInit) {
                        _this4.hasEmitInit = true;
                        _this4.emitter.emit('VIDEO_INIT', {
                            volume: volume || _this4.options.volume || 0.7,
                            resolution: _.get(_this4.options, 'video.quality.'.concat(_.get(_this4.options.video, 'defaultQuality'), '.name'), ''),
                            rate: _this4.video.playbackRate || 1
                        });
                    }
                });
                this.on('canplay', function () {
                    _this4.hasLoaded = true;
                    var now = Date.now();
                    _this4.loadedTime = now;
                    _this4.bufferTime = now - _this4.startTime;
                    _this4.cdnSeedOkDur = _this4.startSwitchCDNTime;
                    if (_this4.isFirstPlay) {
                        _this4.emitter.emit('VIDEO_SUCCESSFUL', {
                            cdnSeedCount: _this4.options.video.defaultCdn,
                            cdnSeedOkDur: _this4.cdnSeedOkDur,
                            bufferTime: _this4.bufferTime
                        });
                    }
                    if (!_this4.video.paused && _this4.isFirstPlay) {
                        _this4.isFirstPlay = false;
                        _this4.emitter.emit('VIDEO_PLAY', {
                            cdnSeedCount: _this4.options.video.defaultCdn,
                            cdnSeedOkDur: _this4.cdnSeedOkDur,
                            bufferTime: _this4.bufferTime
                        });
                        _this4.startHeartBeat();
                    }
                    if (_this4.startWaitingTime) {
                        var blockDuration = Date.now() - _this4.startWaitingTime;
                        _this4.startWaitingTime = null;
                        _this4.emitter.emit('VIDEO_ENDBLOCK', { bufferTime: blockDuration });
                    }
                });
                this.on('ended', function () {
                    _this4.emitter.emit('VIDEO_END');
                });
                this.on('replay', function () {
                    _this4.emitter.emit('VIDEO_REPLAY', { replayCount: ++_this4.replayCount });
                });
                this.on('forward', function (_ref) {
                    var startTime = _ref.startTime, endTime = _ref.endTime;
                    _this4.emitter.emit('VIDEO_FORWARD', {
                        startDragPos: startTime,
                        endDragPos: endTime
                    });
                });
                this.on('backward', function (_ref2) {
                    var startTime = _ref2.startTime, endTime = _ref2.endTime;
                    _this4.emitter.emit('VIDEO_BACKWARD', {
                        startDragPos: startTime,
                        endDragPos: endTime
                    });
                });
                this.on('screenshot', function (s) {
                    _this4.emitter.emit('VIDEO_SCREENSHOT', { screenshotState: s ? 'OK' : 'NO' });
                });
                this.on('volumeVary', _.debounce(function (info) {
                    _this4.emitter.emit('VIDEO_VOLUME', info);
                }, 300));
                this.on('resolutionChange', function (info) {
                    _this4.emitter.emit('VIDEO_RESOLUTION', _objectSpread(_objectSpread({}, info), {}, {
                        cdnSeedCount: _this4.options.video.defaultCdn,
                        cdnSeedOkDur: _this4.cdnSeedOkDur
                    }));
                });
                this.on('rateVary', function (info) {
                    _this4.emitter.emit('VIDEO_RATE', info);
                });
                this.on('fullscreen', function () {
                    _this4.emitter.emit('VIDEO_OPENFULL');
                });
                this.on('fullscreen_cancel', function () {
                    _this4.emitter.emit('VIDEO_ENDFULL');
                });
                this.on('openPicture', function () {
                    _this4.emitter.emit('VIDEO_OPENPICTURE');
                });
                this.on('endPicture', function () {
                    _this4.emitter.emit('VIDEO_ENDPICTURE');
                });
                this.on('turnOff', function () {
                    _this4.emitter.emit('VIDEO_OFFTURN');
                });
                this.on('turnOn', function () {
                    _this4.emitter.emit('VIDEO_ONTURN');
                });
                this.on('error', function () {
                    var isSPAD = /SPAD/.test(navigator.userAgent);
                    if (!isSPAD) {
                        _this4.switchToNextCDN();
                    }
                });
            }
        },
        {
            key: 'initSeekWarning',
            value: function initSeekWarning() {
                var _this5 = this;
                if (this.monitor) {
                    return;
                }
                var startTime = 0, endTime = 0;
                var thumbUp = function thumbUp() {
                    var event = '';
                    document.removeEventListener(utils.nameMap.dragEnd, thumbUp);
                    endTime = _this5.video.currentTime;
                    if (startTime < endTime) {
                        event = 'forward';
                    } else {
                        event = 'backward';
                    }
                    _this5.events.trigger(event, {
                        startTime: startTime,
                        endTime: endTime
                    });
                };
                if (!this.options.disableBar) {
                    this.template.playedBarWrap.addEventListener(utils.nameMap.dragStart, function () {
                        startTime = _this5.video.currentTime;
                        document.addEventListener(utils.nameMap.dragEnd, thumbUp);
                    });
                }
            }
        },
        {
            key: 'pause',
            value: function pause(type) {
                _get(_getPrototypeOf(MtPlayer.prototype), 'pause', this).call(this, type);
                this.pauseStart = Date.now();
            }
        },
        {
            key: 'switchToNextCDN',
            value: function switchToNextCDN() {
                var cdn = this.options.video.cdn;
                var trueVideoUri;
                if (cdn) {
                    var routeNum = this.options.video.defaultCdn;
                    if (routeNum < this.options.video.cdn.length - 1) {
                        var isSPAD = /SPAD/.test(navigator.userAgent);
                        if (!isSPAD) {
                            routeNum++;
                        }
                        var prevUrl = this.options.video.url;
                        this.options.video.defaultCdn++;
                        trueVideoUri = (window.location.protocol === 'https:' ? 'https:' : 'http:') + this.options.video.cdn[routeNum] + this.options.video.uri;
                        this.options.video = this.handleVideoData(this.options.video, trueVideoUri, routeNum);
                        if (this.options.video.quality) {
                            this.options.video.url = this.options.video.quality[this.qualityIndex].url;
                        }
                        this.emitter.emit('VIDEO_FAILED', {
                            cdnSeedCount: routeNum,
                            cdnSeedOkDur: this.cdnSeedOkDur,
                            bufferTime: Date.now() - this.startTime,
                            errorSourceUrl: prevUrl,
                            nextSourceUrl: this.options.video.url,
                            sourceUrl: this.options.video.url
                        });
                        this.switchVideo({ url: this.options.video.url || this.video.src });
                        this.startTime = Date.now();
                        this.startSwitchCDNTime = Date.now();
                    } else {
                        this.emitter.emit('VIDEO_ERROR', {
                            cdnSeedCount: routeNum,
                            cdnSeedOkDur: Date.now(),
                            bufferTime: -1,
                            sourceUrl: this.options.video.url
                        });
                    }
                } else {
                    this.emitter.emit('VIDEO_ERROR', {
                        cdnSeedCount: 0,
                        cdnSeedOkDur: 0,
                        bufferTime: -1,
                        sourceUrl: this.options.video.url
                    });
                }
            }
        },
        {
            key: 'handleVideoData',
            value: function handleVideoData(tranUrlData, trueVideoUri, routeNum) {
                return {
                    quality: [
                        {
                            name: '标清480P',
                            text: '标清',
                            url: ''.concat(trueVideoUri, '_480.m3u8')
                        },
                        {
                            name: '高清720P',
                            text: '高清',
                            url: ''.concat(trueVideoUri, '_720.m3u8')
                        },
                        {
                            name: '超清1080P',
                            text: '超清',
                            url: ''.concat(trueVideoUri, '_1080.m3u8')
                        }
                    ],
                    defaultQuality: utils.isDingDing || utils.isSSAI ? 0 : 1,
                    uri: tranUrlData.uri,
                    cdn: tranUrlData.cdn,
                    defaultCdn: routeNum,
                    pic: 'https://file1.classba.cn/homepage.png'
                };
            }
        },
        {
            key: 'play',
            value: function play() {
                _get(_getPrototypeOf(MtPlayer.prototype), 'play', this).call(this);
                if (this.hasLoaded && this.isFirstPlay) {
                    this.isFirstPlay = false;
                    this.startPlayTime = Date.now();
                    this.emitter.emit('VIDEO_PLAY', {
                        cdnSeedCount: this.options.video.defaultCdn,
                        cdnSeedOkDur: this.cdnSeedOkDur,
                        bufferTime: this.bufferTime
                    });
                    this.startHeartBeat();
                } else if (this.hasLoaded && this.pauseStart) {
                    this.emitter.emit('VIDEO_RESUME', { pauseTime: this.toSecond(Date.now() - this.pauseStart) });
                    this.startHeartBeat();
                    this.pauseStart = null;
                }
            }
        },
        {
            key: 'toSecond',
            value: function toSecond(ms) {
                return ((ms || 0) / 1000).toFixed(2);
            }
        },
        {
            key: 'startHeartBeat',
            value: function startHeartBeat() {
                var _this6 = this;
                if (this.heartTimer) {
                    return;
                }
                this.heartTimer = setInterval(function () {
                    _this6.emitter.emit('VIDEO_HEARBEAT', {
                        currentEvent: _this6.emitter.currentEventName,
                        currentEventTime: _this6.toSecond(Date.now() - (_this6.emitter.currentEventStart || Date.now()))
                    });
                }, 5000);
            }
        },
        {
            key: 'stopHeartBeat',
            value: function stopHeartBeat() {
                clearInterval(this.heartTimer);
                this.heartTimer = null;
            }
        },
        {
            key: 'destroy',
            value: function destroy() {
                var _this7 = this;
                if (this.container.innerHTML !== '') {
                    this.pause('AT');
                    this.emitter.emit('VIDEO_CLOSE', {});
                    _get(_getPrototypeOf(MtPlayer.prototype), 'destroy', this).call(this);
                    this.emitter.destroy();
                    this.stopHeartBeat();
                    clearInterval(this.waitingTimer);
                    Object.keys(this.events.events).forEach(function (key) {
                        _this7.off(key);
                    });
                }
            }
        },
        {
            key: 'closeDot',
            value: function closeDot() {
                this.emitter.emit('VIDEO_CLOSE', {});
                this.stopHeartBeat();
            }
        }
    ]);
    return MtPlayer;
}(DPlayer);
export default MtPlayer;